import { io } from 'socket.io-client'

// providers
import envProvider from '@/providers/envProvider.ts'

class Socket {
  socket: any

  constructor() {
    this.socket = null
  }

  initialize() {
    this.socket = io(envProvider.baseURL, {
      path: '/api/socket.io-client',
      query: {
        type: 'presenter',
      },
      transports: ['websocket'],
      withCredentials: true,
    })

    // https://ahaslides.atlassian.net/browse/AHA-4956
    // on reconnection, reset the transports option, as the Websocket
    // connection may have failed (caused by proxy, firewall, browser, ...)
    this.socket.io.on('reconnect_attempt', () => {
      this.socket.io.opts.transports = ['polling', 'websocket']
    })
  }

  on(...props: any[]) {
    return this.socket.on(...props)
  }

  onAny(...props: any[]) {
    return this.socket.onAny(...props)
  }

  offAny(...props: any[]) {
    return this.socket.offAny(...props)
  }

  emit(...props: any[]) {
    return this.socket.emit(...props)
  }

  unSubscribe(channel: any) {
    if (!this.socket) return
    this.socket.removeAllListeners(channel)
  }
}

export default new Socket()
